"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _resourceTimeline = _interopRequireDefault(require("@fullcalendar/resource-timeline"));
var _reservation = require("@/api/reservation");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FullCalendar: function FullCalendar() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@fullcalendar/vue"));
      });
    }
  },
  props: {
    value: {
      type: Object,
      default: {}
    }
  },
  watch: {
    where: {
      handler: function handler(newVal) {
        this.$emit('input', newVal);
      },
      deep: true
    }
  },
  data: function data() {
    var _this = this;
    return {
      marks: {
        30: "30分钟",
        60: "1小时",
        90: "",
        120: "2小时",
        150: "",
        180: "3小时"
      },
      sliderValue: 30,
      checkBox: [2, 3, 4],
      dialogVisible: false,
      calendarOptions: {
        height: "calc(100vh - 276px)",
        // 调整高度以适应顶部日期选择器
        slotMinWidth: 90,
        eventMaxStack: 50,
        moreLinkContent: {
          html: '<a>全部预约<span class="fc-icon fc-icon-chevron-right"></span></a>'
        },
        // moreLinkClick: this.handleMoreLinkClick,
        locale: "zh-cn",
        plugins: [_resourceTimeline.default],
        initialView: "resourceTimelineDay",
        aspectRatio: 3,
        headerToolbar: {
          left: "prev,customTitle,next,volume,number",
          right: ""
        },
        customTitle: {
          text: this.formatDate(this.selectedDate),
          click: function click() {
            _this.dialogVisible = !_this.dialogVisible;
          }
        },
        customButtons: {
          volume: {
            text: "当日预约量"
          },
          number: {
            text: "0"
          },
          customTitle: {
            text: this.formatDate(this.selectedDate),
            click: function click() {
              _this.dialogVisible = !_this.dialogVisible;
            }
          }
        },
        slotLabelFormat: {
          hour: "2-digit",
          // 两位数小时（如 10）
          minute: "2-digit",
          // 两位数分钟（如 00）
          hour12: false,
          // 24小时制
          omitZeroMinute: false,
          // 不省略分钟（强制显示:00）
          locale: "zh-cn" // 本地化（需加载中文语言包）
        },
        nowIndicator: true,
        editable: false,
        droppable: false,
        resourceAreaWidth: "15%",
        scrollTime: "9:00",
        resourceAreaHeaderContent: "",
        resources: [],
        events: [],
        slotDuration: "00:30:00",
        slotLabelInterval: "00:30",
        // 标签间隔2小时
        datesSet: this.handleDatesSet,
        dateClick: this.handleDateChange,
        eventClick: this.handleEventClick,
        schedulerLicenseKey: "GPL-My-Project-Is-Open-Source"
      },
      reservationTime: "",
      where: this.value,
      viewNum: {},
      selectedDate: this.moment().format('YYYY-MM-DD'),
      selectedTime: '',
      calendarApi: null
    };
  },
  beforeDestroy: function beforeDestroy() {
    // 清理事件监听
    document.removeEventListener("click", this.closePopover);
  },
  mounted: function mounted() {
    this.getConfig();
    this.getList();
    this.getViewNum();
    // 初始化日期
    this.where.reservationDate = this.selectedDate;
  },
  methods: {
    getColor: function getColor(serviceStatus) {
      var statusMap = {
        1: '#9fdb1d',
        2: '#377DFF',
        3: '#FF8D30',
        4: '#23C471'
      };
      return statusMap[serviceStatus];
    },
    getViewNum: function () {
      var _getViewNum = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _reservation.workOrderOverViewNumApi)(this.where);
            case 1:
              this.viewNum = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getViewNum() {
        return _getViewNum.apply(this, arguments);
      }
      return getViewNum;
    }(),
    // 预约工单甘特图
    getList: function getList() {
      var _this2 = this;
      for (var key in this.tableFrom) {
        this.where[key] = this.tableFrom[key];
      }
      (0, _reservation.workOrderOverViewApi)(this.where).then(function (res) {
        var data = res.list;
        var staff = [];
        var list = [];
        data.forEach(function (dataItem) {
          staff.push({
            id: dataItem.staffId,
            title: dataItem.staffId == 0 ? "未指派" : dataItem.name
          });
          // 蓝色 待服务，黄色 服务中，绿色 已完成，serviceType	服务类型:1-上门服务，2-到店服务，serviceStatus	服务状态:1-未分配，2-已分配，3-服务中，4-服务结束
          dataItem.workOrderList.forEach(function (item) {
            var color = "#9fdb1d";
            if (item.serviceStatus === 2) {
              // s上面 1
              // 到店 01
              color = "#377DFF";
            } else if (item.serviceStatus === 3) {
              color = "#FF8D30";
            } else if (item.serviceStatus === 4) {
              color = "#23C471";
            }
            var reservationTimeSlotAttr = item.reservationTimeSlot.split('-');
            list.push(_objectSpread(_objectSpread({}, item), {}, {
              id: item.workOrderNo,
              staff_name: dataItem.name,
              resourceId: dataItem.staffId + "",
              start: _this2.moment(item.reservationDate + " " + reservationTimeSlotAttr[0]).format("YYYY-MM-DD HH:mm"),
              end: _this2.moment(item.reservationDate + " " + reservationTimeSlotAttr[1]).format("YYYY-MM-DD HH:mm"),
              color: color
            }));
          });
        });
        _this2.calendarOptions.resources = staff;
        _this2.$nextTick(function () {
          this.$set(this.calendarOptions, "events", list);
        });
        _this2.calendarOptions.customButtons.number.text = res.count + "";
      });
    },
    showPopover: function showPopover() {
      this.dialogVisible = true;
    },
    handleMark: function handleMark(type) {
      if (this.checkBox.includes(type)) {
        this.checkBox = this.checkBox.filter(function (item) {
          return item != type;
        });
        this.where.serviceStatus = this.checkBox.join(",");
      } else {
        this.checkBox.push(type);
        this.where.serviceStatus = this.checkBox.join(",");
      }
      this.getList();
      this.getViewNum();
    },
    handleDateChange: function handleDateChange(date) {
      if (date) {
        // 如果传入的是日期对象，更新selectedDate
        if (date instanceof Date || typeof date === 'string') {
          this.selectedDate = date instanceof Date ? this.moment(date).format('YYYY-MM-DD') : date;
        }
        this.where.reservationDate = this.selectedDate;

        // 如果有选择时间，更新到where对象中
        if (this.selectedTime) {
          this.where.reservationTime = this.selectedTime;
          this.calendarOptions.customButtons.customTitle.text = "".concat(this.selectedDate, " ").concat(this.selectedTime);
        } else {
          this.calendarOptions.customButtons.customTitle.text = this.selectedDate;
        }

        // 立即刷新数据，不使用setTimeout
        this.getList();
        this.getViewNum();

        // 获取日历实例并强制刷新视图
        if (this.$refs.fullCalendarRef) {
          this.calendarApi = this.$refs.fullCalendarRef.getApi();
          if (this.calendarApi) {
            // 设置日期视图到选中的日期
            this.calendarApi.gotoDate(this.selectedDate);
            // 强制重新渲染
            this.calendarApi.refetchEvents();
          }
        }
      }
      // 关闭日期选择器
      this.dialogVisible = false;
    },
    handleDatesSet: function handleDatesSet(arg) {
      this.where.reservationDate = this.moment(arg.start).format("YYYY-MM-DD");
      this.selectedDate = this.where.reservationDate;
      // 如果有选择时间，更新标题
      if (this.selectedTime) {
        this.calendarOptions.customButtons.customTitle.text = "".concat(this.where.reservationDate, " ").concat(this.selectedTime);
      } else {
        this.calendarOptions.customButtons.customTitle.text = this.where.reservationDate;
      }
      this.getList();
      this.getViewNum();
    },
    // 日期选择相关方法
    formatDate: function formatDate(date) {
      if (!date) {
        return (0, _moment.default)().format('YYYY年MM月DD日');
      }
      return (0, _moment.default)(date).format('YYYY年MM月DD日');
    },
    handleEventClick: function handleEventClick(_ref) {
      var event = _ref.event;
      this.$emit("onOrderDetails", event.extendedProps.workOrderNo);
    },
    // 保存看板配置
    setConfig: function setConfig() {
      localStorage.setItem("sliderValue", this.sliderValue);
      this.dialogVisible = false;
      this.getConfig();
    },
    getConfig: function getConfig() {
      var value = 30;
      if (localStorage.getItem("sliderValue")) {
        value = localStorage.getItem("sliderValue");
      }
      this.sliderValue = Number(value);
      this.calendarOptions.slotDuration = this.moment.utc(this.sliderValue * 60 * 1000).format("HH:mm:ss");
      this.calendarOptions.slotLabelInterval = this.moment.utc(this.sliderValue * 60 * 1000).format("HH:mm:ss");
    },
    close: function close() {
      this.modal = false;
    },
    handleRefresh: function handleRefresh() {
      this.isRefresh = true;
    },
    handleMoreLinkClick: function handleMoreLinkClick(info) {
      info.jsEvent.preventDefault();
      var currentEvent = info.hiddenSegs[0].event;
      var resources = currentEvent.getResources();
      var rawEvents = resources[0].getEvents();
      var overlapEvents = rawEvents.filter(function (_ref2) {
        var start = _ref2.start,
          end = _ref2.end;
        return currentEvent.start <= end && start < currentEvent.end;
      });
      overlapEvents.sort(function (a, b) {
        return a.start - b.start;
      });
      var eventList = overlapEvents.map(function (_ref3) {
        var extendedProps = _ref3.extendedProps,
          id = _ref3.id;
        return _objectSpread(_objectSpread({}, extendedProps), {}, {
          id: id
        });
      });
      this.$emit("serviceTap", eventList);
    }
  }
};